<template>
  <div class="customer-type-selection" data-private-info="true">
    <RadioGroup
      v-model="inputModelValue"
      aria-label="Kundentyp auswählen"
      label="Kundentyp auswählen"
      :options="options"
      :name="'customer_' + componentId"
      :theme="theme"
      :direction="direction"
    />
  </div>
</template>
<!--
  @keyup.space="(e) => handleSpace(e)"  
 -->
<script setup>
// todo this should be a more generic component and not only for the calculator
import './CustomerTypeSelection.scss';
import { computed } from 'vue';
import RadioGroup from 'ewi-ui/components/2-molecules/RadioGroup/RadioGroup.vue';
const props = defineProps({
  modelValue: String,
  componentId: String,
  theme: String,
  options: Array,
  direction: {
    type: String,
    default: 'vertical',
  },
});

const options = computed(() => props.options);
const emit = defineEmits(['update:modelValue']);

const handleSpace = (e) => {
  e.preventDefault();
  // e.stopPropagation();
  // emit('update:modelValue', e.target.value);
};

const handleArrowRight = (e, value) => {
  e.preventDefault();
  e.stopPropagation();
  const idx = options.value.findIndex((o) => o.value === value);
  if (idx < options.value.length - 1) {
    emit('update:modelValue', options.value[idx + 1].value);
  } else {
    emit('update:modelValue', options.value[0].value);
  }
};

const handleArrowLeft = (e, value) => {
  e.preventDefault();
  e.stopPropagation();
  const idx = options.value.findIndex((o) => o.value === value);
  if (idx > 0) {
    emit('update:modelValue', options.value[idx - 1].value);
  } else {
    emit('update:modelValue', options.value[options.value.length - 1].value);
  }
};

const inputModelValue = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});
</script>
